module.exports = __webpack_public_path__ + "static/media/petrolpump.6dcaef82.jpg";